<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.form list") }}</h5>
         <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17" alt="Add Form"
          style="cursor: pointer;" @click="addNewRow" />
        <div class="tool-tip mt-2">Add Form</div>
      </div>
      </div>
      <div class="ibox-content">
       
        <div >
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th class="text-center"> Form Id</th>
                <th class="wrap-text">{{ $t("navigations.form name") }} <sup><i class="fa fa-asterisk required"></i></sup></th>
                <th>{{ $t("navigations.language") }}</th>
                 <th>{{ $t("navigations.version") }}</th>
                <th class="text-center">Edit</th>
                  <th class="text-center">Delete</th>
              </tr>            
            </thead>      
            <tbody>
               <!-- New Row for creation -->
              <tr v-if="isAddingNew">
                <td class="text-center">
                  <input v-model="newRow.formId" class="form-control" type="text"
                    @input="clearNewFieldError('formId')" />
                  <div v-if="newRowErrors.formId" class="text-danger">{{ newRowErrors.formId }}</div>
                </td>
                <td>
                  <input v-model="newRow.formName" class="form-control" type="text"
                    @input="clearNewFieldError('formName')" />
                  <div v-if="newRowErrors.formName" class="text-danger">{{ newRowErrors.formName }}</div>
                </td>
                <td>
                  <input v-model="newRow.language" class="form-control" type="text"
                     />
                </td>
                <td>
                  <input v-model="newRow.version" class="form-control" type="text"
                     />
                </td>
                <td class="text-center">
                  <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                  <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                </td>
                <td></td>
              </tr>

              <!-- No data row -->
              <tr v-if="!isAddingNew && FormList.length === 0">
                <td colspan="5" class="text-center">No data available.</td>
              </tr>
              <tr v-for="(study, index) in FormList" :key="study.studyId">
                <td class="text-center" v-if="editIndex !== index">{{ study.formId }}</td>
                <td v-else>
                  <input
                    v-model="editableRow.formId"
                    class="form-control"
                    type="text"
                    
                  />
                </td>
                <td class="wrap-text" v-if="editIndex !== index">{{ study.formName }}</td>
                <td v-else>
                  <input
                    v-model="editableRow.formName"
                    class="form-control"
                    type="text"
                     @input="clearFieldError('formName')"
                  />
                   <div v-if="validationErrors.formName" class="text-danger">
                      {{ validationErrors.formName }}
                    </div>
                </td>
               <td v-if="editIndex !== index">{{ study.language.join(', ') }}</td>
                <td v-else>
                  <input
                    v-model="editableRow.language"
                    class="form-control"
                    type="text"
                  />
                </td>
                <td v-if="editIndex !== index">{{ study.version }}</td>
                <td v-else>
                  <input
                    v-model="editableRow.version"
                    class="form-control"
                    type="text"
                  />
                </td>
                <td class="text-center">
                  <template v-if="editIndex !== index">
                    <i
                      class="fa fa-edit edit-delete"
                       v-if="protocol.status !== 'Generated'"
                      @click.prevent="editRow(index, study)"
                    ></i>
                  </template>
                  <!-- //../../../assets/img/video_requests.png -->
                  <template v-else>
                    <!-- Update icon -->
                    <i
                      class="fa fa-check action-icon text-success"
                      @click="updateRow(study.id,study.studyId)"
                      title="Update"
                    ></i>
                   
                    <i
                      class="fa fa-times action-icon text-danger"
                      @click="cancelEdit"
                      title="Cancel"
                    ></i>
                  </template>
                </td>
                  <td class="text-center">
                  <i class="fa fa-trash edit-delete"  v-if="protocol.status !== 'Generated'" style="color: #a13b7c" @click="deleteRow(study.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Pagination  -->
          <div class="row mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="
                    dataTables_paginate
                    paging_simple_numbers
                    pagination
                    float-right
                  ">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#618bd7"
                    @update:modelValue="loadPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745; 
}
.wrap-text {
  max-width:50ch;
  word-wrap: break-word;
  white-space: normal;
}

.text-danger {
  color: #dc3545;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>
<script src="./FormManagement.js"></script>
